<!-- attendance-report.component.html -->

<!-- ══ MODALE — Récapitulatif congés salarié ══════════════════════════════════ -->
<div *ngIf="showLeaveSummaryModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
  (click)="onLeaveSummaryBackdrop($event)">

  <div class="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col">

    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-4 border-b flex-shrink-0">
      <div>
        <h2 class="text-lg font-bold text-gray-900">Récapitulatif des congés</h2>
        <p *ngIf="leaveSummary" class="text-sm text-gray-500 mt-0.5">
          {{ leaveSummary.workerFirstName }} {{ leaveSummary.workerLastName }}
        </p>
      </div>
      <button (click)="closeLeaveSummary()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="overflow-y-auto flex-1 p-6">

      <!-- Chargement -->
      <div *ngIf="isLoadingLeaveSummary" class="flex justify-center py-10">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2" style="border-color: #143A72;"></div>
      </div>

      <!-- Erreur -->
      <div *ngIf="leaveSummaryError && !isLoadingLeaveSummary"
        class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
        {{ leaveSummaryError }}
      </div>

      <ng-container *ngIf="leaveSummary && !isLoadingLeaveSummary">

        <!-- Compteurs -->
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
          <div class="bg-blue-50 rounded-xl p-4 text-center border border-blue-100">
            <p class="text-2xl font-bold text-blue-700">{{ leaveSummary.totalAccruedDays }}</p>
            <p class="text-xs text-blue-500 mt-1 font-medium">Acquis</p>
          </div>
          <div class="bg-green-50 rounded-xl p-4 text-center border border-green-100">
            <p class="text-2xl font-bold text-green-700">{{ leaveSummary.remainingDays }}</p>
            <p class="text-xs text-green-500 mt-1 font-medium">Restants</p>
          </div>
          <div class="bg-gray-50 rounded-xl p-4 text-center border border-gray-200">
            <p class="text-2xl font-bold text-gray-700">{{ leaveSummary.usedDays }}</p>
            <p class="text-xs text-gray-500 mt-1 font-medium">Utilisés</p>
          </div>
          <div class="bg-yellow-50 rounded-xl p-4 text-center border border-yellow-100">
            <p class="text-2xl font-bold text-yellow-700">{{ leaveSummary.pendingDays }}</p>
            <p class="text-xs text-yellow-500 mt-1 font-medium">En attente</p>
          </div>
        </div>

        <!-- Historique -->
        <h3 class="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wider">Historique</h3>

        <div *ngIf="leaveSummary.history.length === 0"
          class="text-center py-8 text-gray-400 text-sm">
          Aucune demande de congé enregistrée.
        </div>

        <div *ngFor="let h of leaveSummary.history"
          class="border border-gray-100 rounded-xl p-4 mb-3 hover:bg-gray-50 transition-colors">
          <div class="flex items-start justify-between gap-4">
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="text-sm font-medium text-gray-800">
                  {{ formatLeaveDate(h.startDate) }} → {{ formatLeaveDate(h.endDate) }}
                </span>
                <span class="text-xs text-gray-400">({{ h.requestedDays }}j)</span>
              </div>
              <p *ngIf="h.reason" class="text-xs text-gray-500 mt-1 truncate">{{ h.reason }}</p>
              <p *ngIf="h.reviewedByName" class="text-xs text-gray-400 mt-0.5">
                Traité par {{ h.reviewedByName }}
                <span *ngIf="h.managerComment"> · {{ h.managerComment }}</span>
              </p>
            </div>
            <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border flex-shrink-0"
              [ngClass]="getLeaveStatusClass(h.status)">
              {{ getLeaveStatusLabel(h.status) }}
            </span>
          </div>
        </div>

      </ng-container>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t flex-shrink-0 flex justify-end">
      <button (click)="closeLeaveSummary()"
        class="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
        Fermer
      </button>
    </div>
  </div>
</div>

<div class="container mx-auto px-4">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 gap-4">
    <h2 class="text-xl font-bold text-gray-800">{{ t('attendanceReport.title') }}</h2>

    <div class="flex items-center gap-3 flex-wrap">
      <!-- Month Selector -->
      <div class="relative">
        <select [(ngModel)]="selectedMonth" (ngModelChange)="onMonthChange()"
          class="h-11 px-4 pr-10 bg-white border border-gray-300 rounded-lg text-sm appearance-none cursor-pointer
                 focus:outline-none focus:ring-2 focus:border-[#143A72]"
          style="--tw-ring-color: #143A72;">
          <option *ngFor="let month of availableMonths" [value]="month.value">
            {{ month.label }}
          </option>
        </select>
        <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd" />
          </svg>
        </div>
      </div>

      <!-- Export Button -->
      <button (click)="exportToExcel()" [disabled]="!report || !report.workers || report.workers.length === 0"
        class="h-11 px-5 text-white rounded-lg
               flex items-center gap-2 text-sm font-medium transition-colors whitespace-nowrap shadow-sm
               disabled:opacity-50 disabled:cursor-not-allowed"
        style="background-color: #143A72;"
        onmouseover="this.style.backgroundColor='#0f2d5a'"
        onmouseout="this.style.backgroundColor='#143A72'">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        {{ t('attendanceReport.exportExcel') }}
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-16">
    <div class="flex flex-col items-center gap-4">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2" style="border-color: #143A72;"></div>
      <p class="text-gray-500 text-sm">{{ t('attendanceReport.loading') }}</p>
    </div>
  </div>

  <!-- Error -->
  <div *ngIf="error && !isLoading" class="bg-red-50 border border-red-200 rounded-xl p-8 text-center">
    <svg class="w-16 h-16 mx-auto mb-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
    <p class="text-red-700 font-medium mb-2">{{ error }}</p>
    <button (click)="retry()"
      class="mt-3 px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors text-sm font-medium">
      {{ t('attendanceReport.retry') }}
    </button>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && !error && report && report.workers && report.workers.length === 0"
    class="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center">
    <svg class="w-16 h-16 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
      </path>
    </svg>
    <p class="text-lg font-medium text-gray-600">{{ t('attendanceReport.noData') }}</p>
    <p class="text-sm text-gray-400 mt-1">{{ t('attendanceReport.noDataHint') }}</p>
  </div>

  <!-- Report Content -->
  <div *ngIf="!isLoading && !error && report && report.workers && report.workers.length > 0">

    <!-- Project Name & Month -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-5 mb-6">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style="background-color: rgba(20, 58, 114, 0.1);">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: #143A72;">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </div>
        <div>
          <h3 class="text-lg font-bold text-gray-900">{{ report.realEstateName }}</h3>
          <p class="text-sm text-gray-500">{{ t('attendanceReport.period') }} : {{ getFormattedMonth() }}</p>
        </div>
      </div>
    </div>

    <!-- Metrics Cards -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
      <!-- Total Working Days -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">{{ t('attendanceReport.totalWorkingDays') }}</p>
            <p class="text-3xl font-bold text-gray-900">{{ report.totalWorkingDays }}</p>
          </div>
          <div class="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0">
            <svg class="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Past Working Days -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">{{ t('attendanceReport.pastWorkingDays') }}</p>
            <p class="text-3xl font-bold text-gray-900">{{ report.pastWorkingDays }}</p>
          </div>
          <div class="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style="background-color: rgba(20, 58, 114, 0.1);">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: #143A72;">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Remaining Working Days -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">{{ t('attendanceReport.remainingWorkingDays') }}</p>
            <p class="text-3xl font-bold text-gray-900">{{ report.remainingWorkingDays }}</p>
          </div>
          <div class="w-12 h-12 rounded-xl bg-green-50 flex items-center justify-center flex-shrink-0">
            <svg class="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Workers Table -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <!-- Table Header -->
      <div class="px-6 py-4 border-b border-gray-100 bg-gray-50">
        <div class="flex items-center gap-2">
          <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <h3 class="font-semibold text-gray-800">{{ t('attendanceReport.workersTable') }}</h3>
          <span class="bg-gray-200 text-gray-600 text-xs px-2.5 py-0.5 rounded-full font-medium ml-1">
            {{ report.workers.length }}
          </span>
        </div>
      </div>

      <!-- Scrollable Table -->
      <div class="overflow-x-auto">
        <table class="w-full min-w-[800px]">
          <thead>
            <tr class="border-b border-gray-100">
              <th class="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                {{ t('attendanceReport.fullName') }}
              </th>
              <th class="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                {{ t('attendanceReport.daysPresent') }}
              </th>
              <th class="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                {{ t('attendanceReport.leaveDays') }}
              </th>
              <th class="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                {{ t('attendanceReport.absentDays') }}
              </th>
              <th class="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                {{ t('attendanceReport.salaryDeduction') }}
              </th>
              <th class="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 180px;">
                {{ t('attendanceReport.presence') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let worker of report.workers; let i = index; let odd = odd"
              class="border-b border-gray-50 hover:bg-gray-50 transition-colors"
              [ngClass]="{'bg-gray-50': odd}">

              <!-- Full Name -->
              <td class="px-6 py-4">
                <div class="flex items-center gap-3">
                  <img src="/avatar-placeholder.svg" alt="Avatar"
                    class="w-9 h-9 rounded-full object-cover flex-shrink-0 border border-gray-200" />
                  <div>
                    <p class="font-medium text-gray-900 text-sm">{{ worker.firstName }} {{ worker.lastName }}</p>
                  </div>
                </div>
              </td>

              <!-- Days Present -->
              <td class="text-center px-4 py-4">
                <span class="inline-flex items-center justify-center w-9 h-9 rounded-lg  text-green-700 font-bold text-sm">
                  {{ worker.daysPresent }}
                </span>
              </td>

              <!-- Leave Days -->
              <td class="text-center px-4 py-4">
                <button (click)="openLeaveSummary(worker)"
                  class="inline-flex items-center justify-center px-2.5 py-1 rounded-lg text-blue-700 font-bold text-sm
                         hover:bg-blue-50 transition-colors"
                  title="Voir le récapitulatif des congés">
                  {{ worker.leaveDays }}
                </button>
              </td>

              <!-- Absent Days -->
              <td class="text-center px-4 py-4">
                <span class="inline-flex items-center justify-center w-9 h-9 rounded-lg  text-red-700 font-bold text-sm">
                  {{ worker.absentDays }}
                </span>
              </td>
              
              <!-- Salary Deduction -->
              <td class="text-center px-4 py-4">
                <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border"
                  [ngClass]="getDeductionBadgeClass(worker.salaryDeductionPercent)">
                  {{ worker.salaryDeductionPercent }}%
                </span>
              </td>

              <!-- Presence Progress Bar -->
              <td class="px-4 py-4">
                <div class="flex items-center gap-3">
                  <div class="flex-1 h-2.5 bg-gray-100 rounded-full overflow-hidden">
                    <div class="h-full rounded-full transition-all duration-500 ease-out"
                      [ngClass]="getProgressBarColor(worker.daysPresent, worker.pastWorkingDays)"
                      [style.width.%]="getProgressPercent(worker.daysPresent, worker.pastWorkingDays)">
                    </div>
                  </div>
                  <span class="text-xs font-semibold text-gray-600 w-10 text-right">
                    {{ getProgressPercent(worker.daysPresent, worker.pastWorkingDays) }}%
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Table Footer / Legend -->
      <div class="px-6 py-4 bg-gray-50 border-t border-gray-100">
        <!-- <div class="flex flex-wrap items-center gap-6 text-xs text-gray-500">
          <div class="flex items-center gap-1.5">
            <div class="w-3 h-3 rounded-full bg-green-500"></div>
            <span>{{ t('attendanceReport.legendGood') }} (&lt; 25%)</span>
          </div>
          <div class="flex items-center gap-1.5">
            <div class="w-3 h-3 rounded-full" style="background-color: #143A72;"></div>
            <span>{{ t('attendanceReport.legendWarning') }} (25-50%)</span>
          </div>
          <div class="flex items-center gap-1.5">
            <div class="w-3 h-3 rounded-full bg-red-500"></div>
            <span>{{ t('attendanceReport.legendCritical') }} (&gt; 50%)</span>
          </div>
        </div> -->
      </div>

      <!-- Pagination -->
      <div *ngIf="totalPages > 1" class="px-6 py-4 flex items-center justify-between border-t bg-gray-50">
        <span class="text-sm text-gray-600">{{ getPaginationText() }}</span>
        <div class="flex items-center space-x-2">
          <!-- Bouton précédent -->
          <button *ngIf="hasPreviousPage()" (click)="previousPage()"
            class="px-4 py-2 rounded-lg hover:bg-gray-100 font-medium flex items-center gap-2 transition-colors"
            style="color: #143A72;">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            {{ t('team.previous') }}
          </button>

          <!-- Numéros de page -->
          <button *ngFor="let page of getPageNumbers()" (click)="goToPage(page)"
            [class]="page === currentPage ?
              'w-10 h-10 rounded-lg text-white font-semibold flex items-center justify-center shadow-sm' :
              'w-10 h-10 rounded-lg hover:bg-gray-100 text-gray-600 font-medium flex items-center justify-center transition-colors'"
            [ngClass]="page === currentPage ? 'bg-[#143A72]' : ''">
            {{ page }}
          </button>

          <!-- Bouton suivant -->
          <button *ngIf="hasNextPage()" (click)="nextPage()"
            class="px-4 py-2 rounded-lg hover:bg-gray-100 font-medium flex items-center gap-2 transition-colors"
            style="color: #143A72;">
            {{ t('team.next') }}
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
